
<div class="wrapper">
<app-nav-bar></app-nav-bar>
<router-outlet id = "content"></router-outlet>
</div>


<app-footer></app-footer>
